import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class EquipmentApiService {
    /*** -------kolize s employeeborrows.component -> putBorrowStatus, deleteBorrow ------*/
    /*** Equipment */
  constructor(private http: HttpClient) { }
    public getEquipments(searchText = ''): Observable<any> {
        return this.http.get('/api/equipment', {params: {filter: searchText}});
    }

    public createEquipment(data): Observable<any> {
        return this.http.post('/api/equipment', data);
    }

    public updateEquipment(id, data): Observable<any> {
        return this.http.put('/api/equipment/' + id, data);
    }

    public deleteEquipment(id): Observable<any> {
        return this.http.delete('/api/equipment/' + id);
    }

    /*** Borrows */
    public getBorrows(filter): Observable<any> {
        return this.http.get('/api/borrows', {params: filter});
    }

    public postEmployeeBorrow(employeeId, data: any): Observable<any> {
        return this.http.post('/api/borrows', data);
    }

    public putEmployeeBorrow(id, data: any): Observable<any> {
        return this.http.put('/api/borrows/' + id, data);
    }

    public deleteBorrow(id): Observable<any> {
        return this.http.delete('/api/borrows/' + id);
    }

    public returnBack(borrowId): Observable<any> {
        let formData = new HttpParams();
        formData = formData.append('idBorrow', borrowId);
        formData = formData.append('status', '2');
        const data = {idBorrow: borrowId, status: 2};
        return this.http.put('/api/borrow/status/change', {params: formData});
    }

    public putBorrowStatus(id, status): Observable<any> {
        return this.http.put('/api/borrows/status/change' , {idBorrow: id, status: status});
    }

}
